var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlipchart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 4C5.25 2.48122 6.48122 1.25 8 1.25H16C17.5188 1.25 18.75 2.48122 18.75 4V16C18.75 17.5188 17.5188 18.75 16 18.75H8C6.48122 18.75 5.25 17.5188 5.25 16V4ZM8 2.75C7.30964 2.75 6.75 3.30964 6.75 4V16C6.75 16.6904 7.30964 17.25 8 17.25H16C16.6904 17.25 17.25 16.6904 17.25 16V4C17.25 3.30964 16.6904 2.75 16 2.75H8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64312 17.3859C8.9983 17.599 9.11348 18.0597 8.90037 18.4149L6.67211 22.1286C6.459 22.4838 5.9983 22.599 5.64312 22.3859C5.28793 22.1728 5.17276 21.7121 5.38587 21.3569L7.61413 17.6431C7.82724 17.2879 8.28793 17.1728 8.64312 17.3859Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3844 17.6C15.7348 17.379 16.1979 17.4839 16.4188 17.8343L18.6187 21.3229C18.8397 21.6733 18.7348 22.1365 18.3844 22.3574C18.034 22.5783 17.5709 22.4734 17.3499 22.123L15.15 18.6344C14.9291 18.284 15.034 17.8209 15.3844 17.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 3.75H6.5V2.25H17.5V3.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 8C8.25 7.58579 8.58579 7.25 9 7.25H15C15.4142 7.25 15.75 7.58579 15.75 8C15.75 8.41421 15.4142 8.75 15 8.75H9C8.58579 8.75 8.25 8.41421 8.25 8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 11C8.25 10.5858 8.58579 10.25 9 10.25H12C12.4142 10.25 12.75 10.5858 12.75 11C12.75 11.4142 12.4142 11.75 12 11.75H9C8.58579 11.75 8.25 11.4142 8.25 11Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 4C5.25 2.48122 6.48122 1.25 8 1.25H16C17.5188 1.25 18.75 2.48122 18.75 4V16C18.75 17.5188 17.5188 18.75 16 18.75H8C6.48122 18.75 5.25 17.5188 5.25 16V4ZM8 2.75C7.30964 2.75 6.75 3.30964 6.75 4V16C6.75 16.6904 7.30964 17.25 8 17.25H16C16.6904 17.25 17.25 16.6904 17.25 16V4C17.25 3.30964 16.6904 2.75 16 2.75H8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64312 17.3859C8.9983 17.599 9.11348 18.0597 8.90037 18.4149L6.67211 22.1286C6.459 22.4838 5.9983 22.599 5.64312 22.3859C5.28793 22.1728 5.17276 21.7121 5.38587 21.3569L7.61413 17.6431C7.82724 17.2879 8.28793 17.1728 8.64312 17.3859Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3844 17.6C15.7348 17.379 16.1979 17.4839 16.4188 17.8343L18.6187 21.3229C18.8397 21.6733 18.7348 22.1365 18.3844 22.3574C18.034 22.5783 17.5709 22.4734 17.3499 22.123L15.15 18.6344C14.9291 18.284 15.034 17.8209 15.3844 17.6Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 3.75H6.5V2.25H17.5V3.75Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 8C8.25 7.58579 8.58579 7.25 9 7.25H15C15.4142 7.25 15.75 7.58579 15.75 8C15.75 8.41421 15.4142 8.75 15 8.75H9C8.58579 8.75 8.25 8.41421 8.25 8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 11C8.25 10.5858 8.58579 10.25 9 10.25H12C12.4142 10.25 12.75 10.5858 12.75 11C12.75 11.4142 12.4142 11.75 12 11.75H9C8.58579 11.75 8.25 11.4142 8.25 11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipchart);
export default __webpack_public_path__ + "static/media/Flipchart.c780088d7b1c9cc3a85b532c92dcc961.svg";
export { ForwardRef as ReactComponent };